import { render, staticRenderFns } from "./SecretaryProfile.vue?vue&type=template&id=cc4d1c94&scoped=true&"
import script from "./SecretaryProfile.vue?vue&type=script&lang=js&"
export * from "./SecretaryProfile.vue?vue&type=script&lang=js&"
import style0 from "./SecretaryProfile.vue?vue&type=style&index=0&id=cc4d1c94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4d1c94",
  null
  
)

export default component.exports